/* ==========================================================================
   Ufesa · Recetas — filtro lateral (multi-faceta en cliente)
   - OR dentro de un grupo, AND entre grupos.
   - Chips de filtros activos, contador (aria-live).
   - URL: 1 filtro => /blogs/recetas/tagged/<tag> (página real, indexable);
          2+ filtros => ?f=... (Shopify no admite URL nativa multi-tag).
   - Drawer en móvil. Degradación: sin JS, las opciones son enlaces /tagged/.
   ========================================================================== */
(function () {
	'use strict';

	var form = document.querySelector('[data-recipe-filter]');
	var grid = document.querySelector('[data-recipe-grid]');
	if (!form || !grid) return;

	var cards = Array.prototype.slice.call(grid.querySelectorAll('.rcp-card'));
	var labels = Array.prototype.slice.call(form.querySelectorAll('.rcp-facet__label'));
	var pills = Array.prototype.slice.call(document.querySelectorAll('[data-utensil-pill]'));
	var countEl = document.querySelector('[data-result-count]');
	var chipsEl = document.querySelector('[data-active-chips]');
	var clearBtns = Array.prototype.slice.call(document.querySelectorAll('[data-clear-filters]'));
	var noResults = document.querySelector('[data-no-results]');
	var serverPagination = document.querySelector('[data-server-pagination]');
	var sortSelect = document.querySelector('[data-recipe-sort]');
	var applyBtn = document.querySelector('[data-apply-filters]');
	var applyCount = document.querySelector('[data-apply-count]');
	var paginationEl = document.querySelector('[data-recipe-pagination]');
	var DEFAULT_SORT = 'date-desc';

	// Página de servidor con la que se ha aterrizado. Se lee AQUÍ porque `syncURL`
	// reescribe la URL (quita el ?page=) en el primer `apply()` del init.
	var INITIAL_PAGE = parseInt((window.location.search.match(/[?&]page=(\d+)/) || [])[1], 10) || 1;

	// Paginación en cliente sobre el set filtrado global
	var PER_PAGE = parseInt(grid.getAttribute('data-per-page'), 10) || 12;
	var currentPage = 1;
	var matched = [];

	// Solo tomamos el control de la paginación si la nueva plantilla cargó (existe
	// el contenedor cliente). Si no, dejamos la paginación de servidor intacta para
	// no dejar artículos inalcanzables (evita el caso "solo salen 12").
	if (serverPagination && paginationEl) serverPagination.hidden = true;

	/* --- índice de tarjetas + conteo por tag -------------------------------
	   Se recalcula cuando se añaden las recetas de las páginas siguientes
	   (ver `loadRemainingPages`), para que los contadores sean del blog entero. */
	function refreshIndex() {
		cards = Array.prototype.slice.call(grid.querySelectorAll('.rcp-card'));

		var counts = {};
		cards.forEach(function (card) {
			(card.getAttribute('data-tags') || '').split('|').forEach(function (t) {
				if (t) counts[t] = (counts[t] || 0) + 1;
			});
		});
		form.querySelectorAll('[data-count]').forEach(function (el) {
			var n = counts[el.getAttribute('data-count')] || 0;
			el.textContent = n ? '(' + n + ')' : '';
		});
	}
	refreshIndex();

	/* --- estado ------------------------------------------------------------ */
	function getActive() {
		return Array.prototype.slice
			.call(form.querySelectorAll('.rcp-facet__input:checked'))
			.map(function (i) { return i; });
	}

	function inputFor(tag) {
		return form.querySelector('.rcp-facet__input[value="' + cssEscape(tag) + '"]');
	}

	function labelFor(tag) {
		var input = inputFor(tag);
		if (!input) return tag;
		var lab = input.parentNode.querySelector('.rcp-facet__name');
		return lab ? lab.textContent.trim() : tag;
	}

	function cssEscape(s) {
		return String(s).replace(/["\\]/g, '\\$&');
	}

	/* --- filtrado GLOBAL ---------------------------------------------------
	   Recorre TODOS los artículos del blog (todos están en el DOM), en el orden
	   actual (respeta la ordenación), y devuelve los que pasan el filtro. */
	function computeMatched() {
		var active = getActive();
		var groups = {};
		active.forEach(function (input) {
			var g = input.getAttribute('data-group') || '_';
			(groups[g] = groups[g] || []).push(input.value);
		});
		var groupKeys = Object.keys(groups);

		return Array.prototype.slice.call(grid.querySelectorAll('.rcp-card')).filter(function (card) {
			var tags = (card.getAttribute('data-tags') || '').split('|');
			return groupKeys.every(function (g) {
				return groups[g].some(function (t) { return tags.indexOf(t) !== -1; });
			});
		});
	}

	function apply() {
		var active = getActive();
		matched = computeMatched();
		currentPage = 1;

		// Sincronizar estado visual de labels (box + aria)
		labels.forEach(function (a) {
			var input = a.previousElementSibling;
			var on = input && input.checked;
			a.setAttribute('aria-checked', on ? 'true' : 'false');
			a.classList.toggle('is-checked', !!on);
		});

		// Sincronizar las píldoras superiores con sus checkboxes
		pills.forEach(function (p) {
			var input = inputFor(p.getAttribute('data-utensil-pill'));
			var on = input && input.checked;
			p.classList.toggle('is-active', !!on);
			p.setAttribute('aria-pressed', on ? 'true' : 'false');
		});

		// Contador (total del set filtrado, no solo la página visible)
		var label = matched.length === 1 ? '1 receta' : matched.length + ' recetas';
		if (countEl) countEl.textContent = label;
		if (applyCount) applyCount.textContent = label;

		// Estado vacío
		if (noResults) noResults.hidden = matched.length !== 0;

		// Chips + botón limpiar
		renderChips(active);
		clearBtns.forEach(function (b) { b.hidden = active.length === 0; });

		syncURL(active);
		renderPage();
	}

	/* --- paginación en cliente (sobre el set filtrado) --------------------- */
	function renderPage() {
		var allCards = Array.prototype.slice.call(grid.querySelectorAll('.rcp-card'));

		// Sin contenedor de paginación (plantilla vieja/no recargada): NO paginamos.
		// Mostramos todo el set filtrado para no ocultar artículos de forma inalcanzable.
		if (!paginationEl) {
			allCards.forEach(function (c) { c.hidden = matched.indexOf(c) === -1; });
			return;
		}

		var totalPages = Math.max(1, Math.ceil(matched.length / PER_PAGE));
		if (currentPage > totalPages) currentPage = totalPages;
		if (currentPage < 1) currentPage = 1;

		var start = (currentPage - 1) * PER_PAGE;
		var end = start + PER_PAGE;

		// Ocultar todo y mostrar solo la porción de la página actual del set filtrado.
		allCards.forEach(function (c) { c.hidden = true; });
		matched.slice(start, end).forEach(function (c) { c.hidden = false; });

		buildPagination(totalPages);
	}

	function pageList(total, current) {
		var out = [];
		for (var i = 1; i <= total; i++) {
			if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) {
				out.push(i);
			} else if (out[out.length - 1] !== '…') {
				out.push('…');
			}
		}
		return out;
	}

	function buildPagination(totalPages) {
		if (!paginationEl) return;
		if (totalPages <= 1) {
			paginationEl.hidden = true;
			paginationEl.innerHTML = '';
			return;
		}
		paginationEl.hidden = false;

		var html = currentPage > 1
			? '<button type="button" class="rcp-pagination__edge" data-page="' + (currentPage - 1) + '" rel="prev">Anterior</button>'
			: '<span class="rcp-pagination__edge is-disabled" aria-disabled="true">Anterior</span>';

		html += '<ol class="rcp-pagination__pages">';
		pageList(totalPages, currentPage).forEach(function (p) {
			if (p === '…') {
				html += '<li class="rcp-pagination__item"><span class="rcp-pagination__ellipsis" aria-hidden="true">…</span></li>';
			} else if (p === currentPage) {
				html += '<li class="rcp-pagination__item"><span class="rcp-pagination__page is-current" aria-current="page">' + p + '</span></li>';
			} else {
				html += '<li class="rcp-pagination__item"><button type="button" class="rcp-pagination__page" data-page="' + p + '" aria-label="Ir a la página ' + p + '">' + p + '</button></li>';
			}
		});
		html += '</ol>';

		html += currentPage < totalPages
			? '<button type="button" class="rcp-pagination__edge rcp-pagination__edge--next" data-page="' + (currentPage + 1) + '" rel="next">Siguiente</button>'
			: '<span class="rcp-pagination__edge rcp-pagination__edge--next is-disabled" aria-disabled="true">Siguiente</span>';

		paginationEl.innerHTML = html;
	}

	/* --- ordenación en cliente --------------------------------------------- */
	function applySort() {
		if (!sortSelect) return;
		var mode = sortSelect.value;
		var sorted = cards.slice().sort(function (a, b) {
			if (mode === 'title-asc' || mode === 'title-desc') {
				var ta = a.getAttribute('data-title') || '';
				var tb = b.getAttribute('data-title') || '';
				var cmp = ta.localeCompare(tb, 'es');
				return mode === 'title-asc' ? cmp : -cmp;
			}
			var da = parseInt(a.getAttribute('data-date'), 10) || 0;
			var db = parseInt(b.getAttribute('data-date'), 10) || 0;
			return mode === 'date-asc' ? da - db : db - da;
		});
		// Un solo reflow: mover los nodos ya existentes en el orden nuevo.
		var frag = document.createDocumentFragment();
		sorted.forEach(function (c) { frag.appendChild(c); });
		grid.appendChild(frag);
	}

	/* --- chips de filtros activos ----------------------------------------- */
	function renderChips(active) {
		if (!chipsEl) return;
		chipsEl.textContent = '';
		active.forEach(function (input) {
			var tag = input.value;
			var chip = document.createElement('button');
			chip.type = 'button';
			chip.className = 'rcp-chip';
			chip.setAttribute('data-remove', tag);
			chip.innerHTML =
				'<span>' + escapeHtml(labelFor(tag)) + '</span>' +
				'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
			chip.setAttribute('aria-label', 'Quitar filtro ' + labelFor(tag));
			chipsEl.appendChild(chip);
		});
	}

	function escapeHtml(s) {
		var d = document.createElement('div');
		d.textContent = s;
		return d.innerHTML;
	}

	/* --- URL ---------------------------------------------------------------
	   1 filtro  -> URL real /blogs/recetas/tagged/<tag> (página indexable).
	   0 filtros -> /blogs/recetas.
	   2+ filtros -> /blogs/recetas?f=... (Shopify no tiene URL nativa multi-tag). */
	var blogUrl = (form.getAttribute('data-blog-url') || window.location.pathname)
		.replace(/\/tagged\/.*$/, '')
		.replace(/\/$/, '');

	function taggedUrlFor(tag) {
		var el = form.querySelector('.rcp-facet__label[data-tag="' + cssEscape(tag) + '"]')
			|| document.querySelector('[data-utensil-pill="' + cssEscape(tag) + '"]');
		return el ? el.getAttribute('href') : null;
	}

	function syncURL(active) {
		if (!window.history || !window.history.replaceState) return;

		var base;
		var params = [];
		if (active.length === 1) {
			base = taggedUrlFor(active[0].value) || blogUrl;
		} else if (active.length === 0) {
			base = blogUrl || '/';
		} else {
			base = blogUrl || '/';
			params.push('f=' + active.map(function (i) { return encodeURIComponent(i.value); }).join(','));
		}
		if (sortSelect && sortSelect.value !== DEFAULT_SORT) {
			params.push('s=' + encodeURIComponent(sortSelect.value));
		}
		var qs = params.length ? '?' + params.join('&') : '';
		window.history.replaceState({}, '', base + qs);
	}

	function restoreFromURL() {
		var url = new URL(window.location.href);

		var s = url.searchParams.get('s');
		if (s && sortSelect && sortSelect.querySelector('option[value="' + cssEscape(s) + '"]')) {
			sortSelect.value = s;
		}

		// Estado por parámetro (multi-filtro)
		var f = url.searchParams.get('f');
		if (f) {
			f.split(',').filter(Boolean).forEach(function (tag) {
				var input = inputFor(decodeURIComponent(tag));
				if (input) input.checked = true;
			});
		}

		// URL de un solo tag (/tagged/<handle>): marcar su opción para que el
		// estado del panel coincida al aterrizar desde Google o un enlace.
		var m = url.pathname.match(/\/tagged\/([^/?#]+)/);
		if (m) {
			var input = inputFor(decodeURIComponent(m[1]));
			if (input) input.checked = true;
		}
	}

	function toggleTag(tag, on) {
		var input = inputFor(tag);
		if (!input) return;
		input.checked = typeof on === 'boolean' ? on : !input.checked;
		apply();
	}

	/* --- eventos: opciones (labels como toggles) --------------------------- */
	labels.forEach(function (a) {
		a.addEventListener('click', function (e) {
			e.preventDefault();
			var input = a.previousElementSibling;
			if (input) { input.checked = !input.checked; apply(); }
		});
		a.addEventListener('keydown', function (e) {
			if (e.key === ' ' || e.key === 'Spacebar') {
				e.preventDefault();
				a.click();
			}
		});
	});

	/* --- eventos: píldoras de utensilio ------------------------------------ */
	pills.forEach(function (p) {
		p.addEventListener('click', function (e) {
			var input = inputFor(p.getAttribute('data-utensil-pill'));
			// Sin checkbox equivalente (sidebar desactivado): dejar navegar a /tagged/
			if (!input) return;
			e.preventDefault();
			input.checked = !input.checked;
			apply();
		});
	});

	/* --- eventos: chips (quitar) ------------------------------------------- */
	if (chipsEl) {
		chipsEl.addEventListener('click', function (e) {
			var btn = e.target.closest('[data-remove]');
			if (btn) toggleTag(btn.getAttribute('data-remove'), false);
		});
	}

	/* --- limpiar todo ------------------------------------------------------ */
	clearBtns.forEach(function (btn) {
		btn.addEventListener('click', function () {
			getActive().forEach(function (i) { i.checked = false; });
			apply();
		});
	});

	/* --- ordenación --------------------------------------------------------- */
	if (sortSelect) {
		sortSelect.addEventListener('change', function () {
			applySort();   // reordena el DOM
			apply();       // recalcula set filtrado (orden nuevo) + página 1
		});
	}

	/* --- paginación en cliente: cambiar de página -------------------------- */
	if (paginationEl) {
		paginationEl.addEventListener('click', function (e) {
			var btn = e.target.closest('[data-page]');
			if (!btn) return;
			var p = parseInt(btn.getAttribute('data-page'), 10);
			if (!p || p === currentPage) return;
			currentPage = p;
			renderPage();
			if (grid.scrollIntoView) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
		});
	}

	/* --- grupos colapsables ------------------------------------------------ */
	form.querySelectorAll('.rcp-facet__legend').forEach(function (btn) {
		btn.addEventListener('click', function () {
			var expanded = btn.getAttribute('aria-expanded') === 'true';
			btn.setAttribute('aria-expanded', String(!expanded));
			var list = btn.nextElementSibling;
			if (list) list.hidden = expanded;
		});
	});

	/* --- drawer móvil ------------------------------------------------------
	   Reutiliza los primitivos del tema (los mismos del menú de secciones):
	     · `.side-panel.active`   -> anima el panel
	     · `body.open-cc`         -> bloquea el scroll y muestra `.click-capture`
	     · `<side-panel-close>`   -> cierre por X, por overlay y por Escape (app.js)
	   Aquí solo abrimos, y observamos la clase para mantener aria/foco en sync. */
	var sidebar = document.getElementById('rcp-sidebar');
	var toggle = document.querySelector('.rcp-filter-toggle');
	var closeEl = sidebar ? sidebar.querySelector('.side-panel-close') : null;
	var lastFocused = null;

	function isOpen() {
		return !!sidebar && sidebar.classList.contains('active');
	}
	function openDrawer() {
		if (!sidebar || isOpen()) return;
		lastFocused = document.activeElement;
		sidebar.classList.add('active');
		document.body.classList.add('open-cc');
	}
	function closeDrawer() {
		if (!sidebar || !isOpen()) return;
		sidebar.classList.remove('active');
		document.body.classList.remove('open-cc');
	}

	if (toggle) toggle.addEventListener('click', openDrawer);

	// "Ver N recetas": el filtrado ya es en vivo, así que solo cierra el panel.
	if (applyBtn) applyBtn.addEventListener('click', closeDrawer);

	// El cierre puede venir de app.js (X, overlay, Escape) sin pasar por nosotros:
	// observamos la clase para no desincronizar aria-expanded ni el foco.
	if (sidebar && toggle && window.MutationObserver) {
		new MutationObserver(function () {
			var open = isOpen();
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (open) {
				if (closeEl && closeEl.focus) closeEl.focus();
			} else if (lastFocused && lastFocused.focus) {
				lastFocused.focus();
				lastFocused = null;
			}
		}).observe(sidebar, { attributes: true, attributeFilter: ['class'] });
	}

	/* --- resto de páginas del servidor -------------------------------------
	   `{% paginate %}` de Shopify tope en 50 artículos, así que en un blog con
	   más recetas las que caen en la página 2+ no llegan al HTML: quedaban fuera
	   del filtro (contador a 0 aunque la etiqueta existiera) y, al sustituir la
	   paginación de servidor por la de cliente, eran inalcanzables desde el
	   listado. Aquí las traemos por fetch al cargar y las añadimos al grid, para
	   que el filtrado y la paginación sigan siendo globales.

	   Si algo falla, se restaura la paginación de servidor: peor experiencia,
	   pero ninguna receta queda escondida. */
	var MAX_EXTRA_PAGES = 10; // 11 páginas × 50 = 550 recetas; tope de seguridad

	function extraPageUrls() {
		if (!serverPagination) return [];

		var current = INITIAL_PAGE;

		// Cualquier enlace con ?page=N vale: uno para saber cuántas páginas hay y
		// otro como patrón de URL. Se cuenta también la página 1, porque estando
		// en la 2 los enlaces solo apuntan hacia atrás.
		var last = current;
		var pattern = null;
		Array.prototype.slice
			.call(serverPagination.querySelectorAll('a[href]'))
			.forEach(function (a) {
				var href = a.getAttribute('href');
				var m = href && href.match(/[?&]page=(\d+)/);
				if (!m) return;
				if (!pattern) pattern = href;
				last = Math.max(last, parseInt(m[1], 10));
			});
		if (!pattern || last < 2) return [];
		if (last > MAX_EXTRA_PAGES + 1) last = MAX_EXTRA_PAGES + 1;

		// Se traen TODAS menos la que ya está pintada (que no tiene por qué ser la
		// 1: se puede aterrizar en ?page=2 desde Google o sin JS).
		var out = [];
		for (var p = 1; p <= last; p++) {
			if (p === current) continue;
			out.push(pattern.replace(/([?&]page=)\d+/, '$1' + p));
		}
		return out;
	}

	function cardHref(card) {
		var a = card.querySelector('a[href]');
		return a ? a.getAttribute('href') : null;
	}

	function loadRemainingPages() {
		var urls = extraPageUrls();
		if (!urls.length || !window.fetch || !window.DOMParser) return;

		Promise.all(
			urls.map(function (url) {
				return fetch(url, { credentials: 'same-origin' })
					.then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); });
			})
		).then(function (pages) {
			var seen = {};
			cards.forEach(function (c) {
				var h = cardHref(c);
				if (h) seen[h] = true;
			});

			var frag = document.createDocumentFragment();
			var added = 0;
			pages.forEach(function (html) {
				var doc = new DOMParser().parseFromString(html, 'text/html');
				Array.prototype.slice
					.call(doc.querySelectorAll('[data-recipe-grid] .rcp-card'))
					.forEach(function (card) {
						var h = cardHref(card);
						if (h && seen[h]) return;
						if (h) seen[h] = true;
						// Sin animación de entrada: estas tarjetas se insertan ya
						// con la página pintada y `rcp-reveal` las dejaría a 0.
						card.classList.remove('rcp-reveal');
						frag.appendChild(document.importNode(card, true));
						added++;
					});
			});
			if (!added) return;

			// Si el usuario ya está paseando por la paginación, no lo devolvemos
			// a la página 1 al terminar la carga.
			var keepPage = currentPage;
			grid.appendChild(frag);
			refreshIndex();
			applySort();
			apply();
			if (keepPage > 1) {
				currentPage = keepPage;
				renderPage();
			}
		}).catch(function () {
			// Volvemos a enseñar la paginación de servidor como red de seguridad.
			if (serverPagination) serverPagination.hidden = false;
		});
	}

	/* --- init -------------------------------------------------------------- */
	restoreFromURL();
	applySort();
	apply();
	loadRemainingPages();
})();
